<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <mat-label
          ><ng-container i18n>Base Charge </ng-container><ng-container>({{ currencySymbol }}):</ng-container></mat-label
        >
        <input matInput type="number" min="0" formControlName="charge" />
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <mat-label
          ><ng-container i18n>Additional Guests Fee </ng-container
          ><ng-container>({{ currencySymbol }}):</ng-container></mat-label
        >
        <input matInput type="number" min="0" formControlName="extraGuests" />
      </mat-form-field2>
    </div>
  </div>

  <h6 i18n>Discounts & Fees</h6>
  <div class="row">
    <div
      formArrayName="discounts"
      *ngFor="let item of discounts.controls; let i = index; let last = last"
      class="col-md-4 d-flex gap-2"
    >
      <ng-container [formGroupName]="i">
        <mat-form-field2 class="mat-block">
          <mat-label
            ><ng-container i18n>Amount </ng-container><ng-container>({{ currencySymbol }}):</ng-container></mat-label
          >
          <input type="number" formControlName="amount" matInput />
        </mat-form-field2>
        <button
          *ngIf="last"
          (click)="removeDiscountsOrFees(i)"
          class="btn btn-secondary-danger align-input-row-end"
          i18n-matTooltip
          matTooltip="Remove this Discount/Fee"
          type="button"
        >
          <i class="cs-icon cs-icon-trash"></i>
        </button>
      </ng-container>
    </div>
    <div class="col-md-4" *ngIf="discounts.length < discountsOrFeesLimit">
      <button
        (click)="addDiscountsOrFees()"
        class="btn btn-primary mb-3"
        [class.align-input-row-end]="discounts.length > 0"
        type="button"
      >
        <i class="far fa-plus"></i> <ng-container i18n>Add Discount/Fee</ng-container>
      </button>
    </div>
  </div>
  <h6>Taxes</h6>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <mat-label><ng-container i18n>Tax (%):</ng-container></mat-label>
        <input matInput type="number" min="0" formControlName="taxPercent" />
      </mat-form-field2>
    </div>

    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <mat-label
          ><ng-container i18n>Tax </ng-container><ng-container>({{ currencySymbol }}):</ng-container></mat-label
        >
        <input matInput type="number" min="0" formControlName="taxFlat" />
      </mat-form-field2>
    </div>
  </div>
  <div class="bg-active2 p-3 rounded">
    <div *ngIf="getTaxTotal() as taxTotal" class="d-flex align-items-center justify-content-between">
      <span class="text-light text-uppercase" i18n>Tax Total:</span>
      <span class="text-bold" [innerHtml]="taxTotal | tokeetCurrency : inquiry?.rental?.currency"></span>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <span class="text-light text-uppercase" i18n>Total:</span>
      <span class="text-bold" [innerHtml]="getTotal() | tokeetCurrency : inquiry?.rental?.currency"></span>
    </div>
  </div>
</form>

<div class="footer-control">
  <button [disabled]="loading || calculating" (click)="close.emit(true)" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    [disabled]="loading || calculating"
    (click)="reset()"
    type="button"
    class="btn btn-secondary-light"
    i18n-matTooltip
    matTooltip="This will update charges according to current rates added in this rental for this booking's date"
  >
    <i class="far fa-sync"></i> <ng-container i18n>reset</ng-container>
  </button>
  <button *ngIf="!loading && !calculating" (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
  <button
    *ngIf="loading || calculating"
    i18n-matTooltip
    matTooltip="Calculating cost..."
    matTooltipPosition="above"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
